import { useState } from "react";
import { openContextMenu } from "../../../../../../utils/functions";

export default function useCustomContextMenu() {
  const [contextMenuLink, setContextMenuLink] = useState("");
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [showPopup, setShowPopup] = useState(false);

  const handleOpenContextMenu = (event: React.MouseEvent) => {
    openContextMenu(event, setPopupPosition, setShowPopup);
  };

  return {
    showPopup,
    setShowPopup,
    contextMenuLink,
    setContextMenuLink,
    popupPosition,
    setPopupPosition,
    handleOpenContextMenu,
  };
}
